const translations = {
  "en": {
    "·Founding Pass": "·Founding Pass",
    "/ yr": "/ yr",
    "/mo": "/mo",
    "/wk": "/wk",
    "% OFF": "% OFF",
    "After 7 days, renews at $299.99/year unless cancelled.": "After 7 days, renews at $299.99/year unless cancelled.",
    "Best Value": "Best Value",
    "Cancel anytime in Settings.": "Cancel anytime in Settings.",
    "Charged %{var0} every month": "Charged %{var0} every month",
    "Charged $0.00 every year": "Charged $0.00 every year",
    "Christmas Offer": "Christmas Offer",
    "Founding Pass · Limited": "Founding Pass · Limited",
    "Limited to the first 2,000 members.": "Limited to the first 2,000 members.",
    "Most Popular": "Most Popular",
    "One Ed. All your important money decisions, prepared.": "One Ed. All your important money decisions, prepared.",
    "one-time": "one-time",
    "One-time payment · no renewal": "One-time payment · no renewal",
    "Own lifetime access to Ed Complete. Locked-in pricing forever.": "Own lifetime access to Ed Complete. Locked-in pricing forever.",
    "Students, casual observers, and new users testing the waters": "Students, casual observers, and new users testing the market waters with AI."
  },
  "zh-tw": {
    "·Founding Pass": "· 創始會員",
    "/ yr": "/ 年",
    "/mo": "/月",
    "/wk": "/週",
    "% OFF": "% 折扣",
    "After 7 days, renews at $299.99/year unless cancelled.": "7 天後，除非取消，否則將以 US$299.99/年續訂。",
    "Best Value": "最佳價值",
    "Cancel anytime in Settings.": "隨時在設定中取消。",
    "Charged %{var0} every month": "每月收取 %{var0}",
    "Charged $0.00 every year": "每年收取 US$0.00",
    "Christmas Offer": "聖誕節優惠",
    "Founding Pass · Limited": "創始會員 · 限量版",
    "Limited to the first 2,000 members.": "僅限前 2,000 名會員。",
    "Most Popular": "最熱門",
    "One Ed. All your important money decisions, prepared.": "一個 Ed。所有重要的金錢決策，已為你準備完畢。",
    "one-time": "一次性",
    "One-time payment · no renewal": "一次性付款 · 無續訂",
    "Own lifetime access to Ed Complete. Locked-in pricing forever.": "終身擁有 Ed Complete 的存取權。永遠鎖定價格。",
    "Students, casual observers, and new users testing the waters": "學生、一般觀察者和正在使用 AI 試水市場的新使用者。"
  }
};

export default translations;
